import { render, staticRenderFns } from "./TelegramChatVip.vue?vue&type=template&id=76ce3182&scoped=true"
import script from "./TelegramChatVip.vue?vue&type=script&lang=js"
export * from "./TelegramChatVip.vue?vue&type=script&lang=js"
import style0 from "./TelegramChatVip.vue?vue&type=style&index=0&id=76ce3182&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ce3182",
  null
  
)

export default component.exports